import { userService } from '../services';
import { userActionTypes } from '../actions/types';
import { userActions } from '../actions';
import _ from 'lodash';

let buffer = [];

export const jwt = store => next => action => {
  if (typeof action === 'function' && action.toString().includes('dispatch(request(')) {
    buffer.push(action);
  } else if (typeof action !== 'function') {
    buffer.push(action);
  }
  if (action.type === userActionTypes.INVALID_TOKEN) {
    let theStore = store.getState();
    if (_.get(theStore, 'authentication.user')) {
      if (!theStore.authentication.pendingRefreshingToken) {
        store.dispatch({ type: userActionTypes.REFRESHING_TOKEN });

        userService
          .refreshToken()
          .then(response => {
            store.dispatch({
              type: userActionTypes.TOKEN_REFRESHED,
              authToken: response,
            });
            // get the action before the last PENDING_REFRESH_TOKEN (the one which got denied because of token expiration)
            const tempBuffer = _.clone(buffer);
            let pos = tempBuffer.map(e => e.type).indexOf(userActionTypes.TOKEN_REFRESHED) - 1;

            // count back from the invalid token dispatch, and fire off the last dispatch again which was
            // a function. These are to be dispatched, and have the dispatch function passed through to them.
            for (var i = pos; i > -1; i--) {
              if (typeof tempBuffer[i] === 'function') {
                store.dispatch({
                  type: userActionTypes.RESEND,
                  action: tempBuffer[i](store.dispatch, store.getState),
                });
              }
            }
            buffer = [];
          })
          .catch(error => {
            store.dispatch({
              type: userActionTypes.INVALID_REFRESH_TOKEN,
              error: error.error,
            });
          });
      }
    }
  } else if (action.type === userActionTypes.INVALID_REFRESH_TOKEN) {
    buffer = [];
    store.dispatch(userActions.logout());
  } else {
    if (buffer.length > 20) {
      //remove all items but keep the last 20 which forms the buffer
      buffer.splice(0, buffer.length - 20);
    }
    return next(action);
  }
};
